export const useFirebaseEmulator = false;

export const isRankingsLocked = true;

export const currentSeason = "2026";
export const defaultSeason = "2026";

export const myUserEntry = "myUserEntry";
